// extracted by mini-css-extract-plugin
export default {"play-button":"PlayButton_play-button__M1fvz"};